import { render, staticRenderFns } from "./SquareButton.vue?vue&type=template&id=54d17fd5&scoped=true&"
import script from "./SquareButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./SquareButton.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SquareButton.vue?vue&type=style&index=0&id=54d17fd5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d17fd5",
  null
  
)

export default component.exports